<template>
	<nuxtPicture v-if="image?.id"
				 :src="`${image.id}-${image.modified_on}`"
				 :alt="altText"
				 :sizes="sizes"
				 :legacy-format="legacyFormat"
				 :fit="fit"
				 :width="width"
				 :height="height"
				 :provider="provider"
				 :loading="loading"
				 :img-attrs="imgAttrs"
				 class="base-image" />
</template>

<script setup>
const props = defineProps({
	image: {
		type: [Object, String],
		required: true
	},
	alt: {
		type: String,
		default: null,
	},
	sizes: {
		type: String,
		required: false,
		default: 'xs:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw'
	},
	width: {
		type: Number,
		default: null,
	},
	height: {
		type: Number,
		default: null,
	},
	fit: {
		type: String,
		default: null,
	},
	provider: {
		type: String,
		default: 'directus'
	},
	loading: {
		type: String,
		default: 'lazy'
	},
	imgAttrs: {
		type: Object,
		default: () => ({})
	}
})

// const formats = computed(() => {
// 	if (!props.image?.type) return null

// 	return srcFormats(props.image.type)
// })

const legacyFormat = computed(() => {
	if (!props.image?.type) return null

	return splitMimeFormat(props.image.type)
})

const altText = computed(() => {
	return props.alt || props.image?.description || props.image?.altText || null
})

// onMounted(() => {
// console.log('image props fit: ', props.fit)
// })
</script>

<style lang="scss">
picture.base-image {
	max-width: 100%;

	// img {
	// 	width: 100%;
	// }
}
</style>